import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Shield, LogOut, User } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

export default function Navbar() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const isLoggedIn = !!user;

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <nav className="sticky top-0 z-50 bg-white border-b border-gray-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <Shield className="h-8 w-8 text-[#0078D4]" />
            <span className="text-2xl font-bold text-[#003366]">Solving365</span>
          </Link>

          {/* Navigation Links */}
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/#features" className="text-gray-700 hover:text-[#0078D4] font-medium transition-colors">
              Features
            </Link>
            <Link to="/#pricing" className="text-gray-700 hover:text-[#0078D4] font-medium transition-colors">
              Pricing
            </Link>
            <Link to="/#faq" className="text-gray-700 hover:text-[#0078D4] font-medium transition-colors">
              FAQ
            </Link>
            {!isLoggedIn && (
              <Link to="/become-expert" className="text-[#0078D4] hover:text-[#005a9e] font-semibold transition-colors" data-testid="navbar-become-expert">
                Become an Expert
              </Link>
            )}
          </div>

          {/* Auth Buttons */}
          <div className="flex items-center space-x-4">
            {isLoggedIn ? (
              <>
                <Link to={user?.role === 'admin' ? '/admin' : user?.role === 'expert' ? '/expert/dashboard' : '/dashboard'}>
                  <Button variant="outline" className="flex items-center space-x-2" data-testid="navbar-dashboard-btn">
                    <User className="h-4 w-4" />
                    <span className="hidden md:inline">{user?.fullName || 'Dashboard'}</span>
                  </Button>
                </Link>
                <Button 
                  onClick={handleLogout} 
                  variant="ghost"
                  className="flex items-center space-x-2"
                >
                  <LogOut className="h-4 w-4" />
                  <span className="hidden md:inline">Logout</span>
                </Button>
              </>
            ) : (
              <>
                <Link to="/login">
                  <Button variant="outline">Login</Button>
                </Link>
                <Link to="/register">
                  <Button className="bg-[#0078D4] hover:bg-[#005a9e]">Get Started</Button>
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}
